module.exports = __webpack_public_path__ + "static/media/027-Restaurant Cabaret Liquor Store.be1716cc.png";